export default "__VITE_ASSET__DKAVarWt__"